import { message } from "antd";
import axios from "axios";
import setAuthHeader from "../../utils/setAuthHeader";

export const register = (user, history) => (dispatch) => {
  axios
    .post("https://mkart-frontend.herokuapp.com/api/v1/auth/register", user)
    .then((response) => {
      if (response.data.success) {
        message.success("Register successfully");
        history.push("/login");
      }
    })
    .catch((err) => {
      message.error("User is already registerd..!");
    });
};

export const login = (credential, history) => (dispatch) => {
  axios
    .post("https://mkart-frontend.herokuapp.com/api/v1/auth/login", credential)
    .then((response) => {
      setAuthHeader(response.data.token);
      localStorage.setItem("accessInfo", JSON.stringify(response.data));
      dispatch(setUser(response.data));
      message.success("Logged in successfull");
      history.push("/products");
    })
    .catch(() => {
      message.error("User is not registered..please register..!");
    });
};

export const setUser = (user) => (dispatch) => {
  dispatch({ type: "SET_USER", payload: user });
};
